<template>
  <o-datepicker
      placeholder="Click to select..."
      icon="calendar"
      :min-date="today"
      v-model="selectedDate"
      :firstDayOfWeek="1"
      style="width: 200px"
      @update:modelValue="emitDate"
    >
  </o-datepicker>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(
defineProps<{
  defaultDate?: Date;
}>(),
{
  defaultDate: function() { return new Date() }
});

const emit = defineEmits<{
  (e: "dateUpdated", date: Date) : void;
}>();

const today = new Date();
const selectedDate = ref(props.defaultDate);

function emitDate() {
  emit("dateUpdated", selectedDate.value);
}

</script>